import React from 'react';
import { useSiteContext } from '../../context/SiteContext';

const WaitingForApproval = () => {
  const { meetingRole, meetingSettings } = useSiteContext();

  return (
    <div className="min-h-screen bg-[linear-gradient(to_top,_#38275B_0%,_#251A3C_33.33333333333333%,_#140E20_66.66666666666666%,_#000000_100%)] flex items-center justify-center p-4">
      <div className="rounded-2xl p-8 max-w-md w-full mx-4 text-center">
        {/* Logo */}
        <div className="mb-6">
          <img
            alt="R-Link"
            className="h-12 w-auto mx-auto"
            src="/r-link-fav.svg"
          />
        </div>

        {/* Loading Animation */}
        <div className="flex justify-center mb-6">
          <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-[#8e01da]"></div>
        </div>

        {/* Status Message */}
        <h1 className="text-[#8e01da] text-2xl font-bold mb-4">
          {meetingRole === "moderator"
            ? "Waiting for Connection"
            : meetingSettings?.waitingRoomTitle
              ? meetingSettings?.waitingRoomTitle
              : "Waiting for Host to Approve"}
        </h1>

        <p className="text-white text-lg mb-2">
          {meetingRole === "moderator"
            ? "Please wait while we connect you to the meeting"
            : meetingSettings?.waitingRoomMessage
              ? meetingSettings?.waitingRoomMessage
              : "Please wait while the host reviews your request to join"}
        </p>

        <p className="text-gray-400 text-sm">
          {meetingRole === "moderator"
            ? "You will be automatically admitted once connected"
            : meetingSettings?.waitingRoomSubText
              ? meetingSettings?.waitingRoomSubText
              : "You will be automatically admitted once approved"}
        </p>
      </div>
    </div>
  );
};

export default WaitingForApproval;
